module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAENJREFUSEtjZCAS/P///z9IKSMjIyMxWohSBDJo1GB4cI4GxUgKClhsE5ObSFHDSDODiXXFaDoeSel4NFXAQoBmdR4AyQFYD4S3HhQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/image/search/add.png
// module id = k73E
// module chunks = 1